var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-button"},[_c('button',{on:{"click":_vm.proceedToPayment}},[_vm._v("Procéder au paiement")])])
}
var staticRenderFns = []

export { render, staticRenderFns }